import React, { useEffect } from 'react'
import { Home } from '../components/Home'
import { useNavigate } from 'react-router-dom';

interface HomeProps {
  isArabic: boolean;
  handleLanguageChange: () => void;
  sectionTranslations: Record<string, string>;
  currentSection: string;

}
const HomeP = ({ isArabic, handleLanguageChange, sectionTranslations, currentSection }: HomeProps) => {

  function generateTermsUrl(isArabic: boolean): string {
    const languagePrefix = isArabic ? 'ar' : 'en';
    return `/${languagePrefix}`;
  }
  const navigate = useNavigate();

  useEffect(() => {
    if (currentSection !== undefined) {
      const homeUrl = generateTermsUrl(isArabic);
      navigate(homeUrl);
    }
  }, [isArabic, currentSection, navigate]);

  return (
    <div>
      <Home isArabic={isArabic} handleLanguageChange={handleLanguageChange} sectionTranslations={sectionTranslations} />
    </div>
  );
};


export default HomeP